import React from 'react';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const FAQSection = () => {
  const { FaQuestionCircle, FaChevronRight } = Fa6Icons;

  const faqs = [
    {
      q: '2026 年香港支票大寫的正確格式？',
      a: '在香港，支票金額大寫必須使用繁體「正寫」（如：壹、貳、叁）。整數金額後必須補上「圓正」，例如 HK$1,000 應寫為「壹仟圓正」。若是英文，則應寫為「One Thousand Dollars Only」。'
    },
    {
      q: '為什麼支票寫法不能有空格？',
      a: '為了防止支票被他人惡意添加數字篡改金額，書寫大寫文字時應緊貼左側的「港幣 / HKD」字樣，且字與字之間不應留有明顯空隙。Cheque Fill 生成的格式已考慮到防篡改的最佳實踐。'
    },
    {
      q: 'Cheque Fill 支援哪些貨幣與語言？',
      a: '我們支援 10 多種語言，包括繁體中文（香港/澳門標準）、簡體中文、英文（美式/英式）、韓文、德文、法文、西班牙文、意大利文、阿拉伯文及泰文，完美對應全球商務結算需求。'
    }
  ];

  return (
    <section className="mt-12 mb-8" aria-labelledby="faq-title">
      <div className="mb-6">
        <h2
          id="faq-title"
          className="text-xl font-bold text-gray-800 dark:text-gray-100 flex items-center"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-400 mr-3">
            <SafeIcon icon={FaQuestionCircle} />
          </span>
          香港支票金額應該怎樣正確填寫？
        </h2>
        <p className="mt-2 ml-11 text-xs text-gray-500 dark:text-gray-400">
          專業支票寫法指南 · 最近更新：
          <time dateTime="2026-03-07">2026 年 3 月 7 日</time>
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {faqs.map((faq) => (
          <article
            key={faq.q}
            className="p-5 rounded-xl bg-white/40 dark:bg-neutral-800/40 border border-gray-100 dark:border-neutral-700/30 group hover:border-primary-300 dark:hover:border-primary-800 transition-all shadow-sm"
          >
            <h3 className="flex items-center text-sm font-bold text-gray-800 dark:text-gray-200 mb-2">
              <SafeIcon
                icon={FaChevronRight}
                className="text-[10px] text-primary-500 mr-2 group-hover:translate-x-1 transition-transform"
              />
              {faq.q}
            </h3>
            <p className="text-xs text-gray-600 dark:text-gray-400 leading-relaxed">
              {faq.a}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;